/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import Vue from 'vue';
import { CHECK, LOGIN, LOGOUT, REGISTER } from './mutation-types';

export default {
    [CHECK](state) {
        state.authenticated = !!localStorage.getItem('token');
        if (state.authenticated) {
            Vue.$http.defaults.headers.common.Authorization = localStorage.getItem('token');
        }
    },

    [REGISTER]() {
        //
    },

    [LOGIN](state, tokenObject) {
        const token = `${tokenObject.token_type} ${tokenObject.access_token}`;
        state.authenticated = true;
        localStorage.setItem('token', token);
        Vue.$http.defaults.headers.common.Authorization = token;
    },

    [LOGOUT](state) {
        state.authenticated = false;
        localStorage.removeItem('token');
        Vue.$http.defaults.headers.common.Authorization = '';
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js